/*
 * check if current is on server side
 */
export const isServerSide = typeof window === "undefined"
export const isClientSide = !isServerSide

export const isProduction = () =>
  process.env.NEXT_PUBLIC_IS_PRODUCTION === "this_is_prod"
export const isStaging = () =>
  process.env.NEXT_PUBLIC_IS_PRODUCTION === "this_is_staging"
export const isDev = () =>
  process.env.NEXT_PUBLIC_IS_PRODUCTION === "this_is_dev"
